/**
 * 咨询发起页 query type
 * @type {string[]}
 */
export const consultPublishQueryType = ['renewal', 'pic', 'privateServe', 'team'];



// WEBPACK FOOTER //
// ./src/page/consult/lib.js